import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    tableRow: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: 'flex-end',
        padding: '10px 0',
        borderBottom: '1px solid #e9ecef',
        flexWrap: 'wrap',
    },
    tableCell: {
        flexGrow: 1,
        flexBasis: 0,
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 8px',
    },
    tableTag: {
        fontSize: '0.75rem',
        color: '#525f7f',
        fontWeight: '700',
        marginBottom: '4px',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
    },
    tableValue: {
        color: '#172430',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontWeight: '500',
        fontSize: '0.875rem',
        backgroundColor: '#fff',
        padding: '6px 10px',
        borderRadius: '4px',
        minHeight: '34px',
        border: '1px solid #dee2e6',
        boxShadow: '0 1px 2px rgba(50,50,93,.06)',
    },
    tableValueParticipantes: {
        color: '#172430',
        backgroundColor: '#fff',
        padding: '8px 10px',
        fontWeight: '500',
        fontSize: '0.875rem',
        borderRadius: '4px',
        minHeight: '34px',
        border: '1px solid #dee2e6',
        boxShadow: '0 1px 2px rgba(50,50,93,.06)',
    },
}));

const TabDados = ({ order }) => {
    const classes = useStyles();

    return (
        <div>
            <div className={classes.tableRow}>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Requerente</div>
                    <div className={classes.tableValue}>{order.titular}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Documento</div>
                    <div className={classes.tableValue}>{order.titular_document}</div>
                </div>
            </div>

            <div className={classes.tableRow}>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Procedimento</div>
                    <div className={classes.tableValue}>{order.procedure}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Natureza</div>
                    <div className={classes.tableValue}>{order.nature}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Data Expedição</div>
                    <div className={classes.tableValue}>{order.trf_protocol_date}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Ano orçamento</div>
                    <div className={classes.tableValue}>{order.proposal_year}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Ano de liquidação</div>
                    <div className={classes.tableValue}>{order.account_settlement_date}</div>
                </div>
            </div>

            <div className={classes.tableRow}>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Status TRF3</div>
                    <div className={classes.tableValue}>{order.requisition_status}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Requerido</div>
                    <div className={classes.tableValue}>{order.defendant}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Advogado</div>
                    <div className={classes.tableValue}>{order.lawyer}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Juízo de Origem</div>
                    <div className={classes.tableValue}>{order.originating_court}</div>
                </div>
            </div>

            <div className={classes.tableRow}>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Status do Processamento</div>
                    <div className={classes.tableValue}>{order.process_status}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Id do Processo</div>
                    <div className={classes.tableValue}>{order.id}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Processos originários</div>
                    <div className={classes.tableValue}>{order.original_processes}</div>
                </div>
                <div className={classes.tableCell}>
                    <div className={classes.tableTag}>Processo Cumprimento de Sentença</div>
                    <div className={classes.tableValue}>{order.process_number}</div>
                </div>
            </div>

            <>
                <div className={classes.tableRow}>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Data da distribuição</div>
                        <div className={classes.tableValue}>{order.distribution_date}</div>
                    </div>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Classe Judicial</div>
                        <div className={classes.tableValue}>{order.judicial_class}</div>
                    </div>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Jurisdição</div>
                        <div className={classes.tableValue}>{order.jurisdiction}</div>
                    </div>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Orgão Julgador</div>
                        <div className={classes.tableValue}>{order.judging_body}</div>
                    </div>
                </div>
                <div className={classes.tableRow}>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Assunto</div>
                        <div className={classes.tableValue} style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', minHeight: '1em', height: "auto" }}>
                            {order.subject}
                        </div>
                    </div>
                </div>
                <div className={classes.tableRow}>
                    <div className={classes.tableCell}>
                        <div className={classes.tableTag}>Participantes</div>
                        <div className={classes.tableValueParticipantes}>
                            {(order.participants || '').split("|").map((participant, index) => (
                                <div key={`order-${order.id}-participant-${index}`}>{participant.trim()}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </>
        </div>
    );
};

export default TabDados;
